export const normalizeModifierSummary = (modifiers = []) =>
  [...(modifiers || [])]
    .map((modifier) => ({
      groupName: modifier.groupName || '',
      optionName: modifier.optionName || '',
      priceDelta: Number(modifier.priceDelta || 0),
    }))
    .sort((left, right) => {
      if (left.groupName !== right.groupName) {
        return left.groupName.localeCompare(right.groupName, 'tr');
      }
      if (left.optionName !== right.optionName) {
        return left.optionName.localeCompare(right.optionName, 'tr');
      }
      return left.priceDelta - right.priceDelta;
    });

export const formatModifierSummary = (modifiers = []) =>
  normalizeModifierSummary(modifiers)
    .map((modifier) => modifier.optionName || modifier.groupName)
    .join(', ');

export const buildSelectedModifierPayload = (selectedModifierOptions = []) =>
  [...(selectedModifierOptions || [])]
    .filter((entry) => Number(entry?.group_id || entry?.groupId) > 0 && Number(entry?.option_id || entry?.optionId) > 0)
    .map((entry) => ({
      group_id: Number(entry.group_id || entry.groupId),
      option_id: Number(entry.option_id || entry.optionId),
    }))
    .sort((left, right) => left.group_id - right.group_id || left.option_id - right.option_id);

export const buildDefaultModifierSelectionMap = (modifierGroups = []) =>
  (modifierGroups || []).reduce((acc, group) => {
    const maxSelections = Number(group?.maxSelections || 1);
    const defaultOption = maxSelections === 1
      ? (group?.options || []).find((option) => option?.isDefault === true)
      : null;

    return {
      ...acc,
      [group.id]: defaultOption ? [defaultOption.id] : [],
    };
  }, {});

export const getItemSignature = (item) => {
  if (item?.lineKey) {
    return item.lineKey;
  }
  if (item?.orderItemId) {
    return `order-item:${item.orderItemId}`;
  }
  return JSON.stringify({
    id: item?.id,
    notes: item?.notes || '',
    modifiers: normalizeModifierSummary(item?.modifiers || []),
    selectedModifierOptions: buildSelectedModifierPayload(item?.selectedModifierOptions || []),
  });
};

export const groupItemsById = (items) => {
  const groupedItems = items.reduce((acc, item) => {
    const itemKey = getItemSignature(item);
    const existingItem = acc.find((entry) => entry.lineKey === itemKey);
    if (existingItem) {
      existingItem.quantity += item.quantity || 1;
      if (!existingItem.notes && item.notes) {
        existingItem.notes = item.notes;
      }
      if (!existingItem.orderItemId && item.orderItemId) {
        existingItem.orderItemId = item.orderItemId;
      }
    } else {
      acc.push({
        ...item,
        lineKey: itemKey,
        quantity: item.quantity || 1,
        notes: item.notes || '',
        modifiers: normalizeModifierSummary(item.modifiers || []),
        selectedModifierOptions: buildSelectedModifierPayload(item.selectedModifierOptions || []),
      });
    }
    return acc;
  }, []);
  return groupedItems;
};

export const compareItems = (initialItems, currentItems) => {
  if (initialItems.length !== currentItems.length) {
    return true;
  }
  for (let i = 0; i < initialItems.length; i += 1) {
    const initialItem = initialItems[i];
    const currentItem = currentItems.find((item) => item.lineKey === initialItem.lineKey);
    if (
      !currentItem ||
      currentItem.quantity !== initialItem.quantity ||
      (currentItem.notes || '') !== (initialItem.notes || '') ||
      JSON.stringify(currentItem.selectedModifierOptions || []) !== JSON.stringify(initialItem.selectedModifierOptions || [])
    ) {
      return true;
    }
  }
  return false;
};

export const calculateTotal = (selectedItems) =>
  selectedItems
    .reduce((total, item) => {
      const itemTotal = Number(item.price || 0) * Number(item.quantity || 1);
      return total + itemTotal;
    }, 0)
    .toFixed(2);

export const calculateItemTotal = (item) =>
  (Number(item.price || 0) * Number(item.quantity || 1)).toFixed(2);

export const getStatusText = (status) => {
  switch (status) {
    case 'pending':
      return 'Bekliyor';
    case 'preparing':
      return 'Hazırlanıyor';
    case 'completed':
      return 'Tamamlandı';
    default:
      return '';
  }
};
